module.exports = __webpack_public_path__ + "img/h-hetong-type-icon2.5f40e109.png";